export default {
  appTitle: 'Pet Health Management System',
  appSubtitle: '🐾 Your Digital Pet Care Partner',
  createPetProfileDesc: 'Easily create pet profiles, track health, and share information securely with caregivers. Care for your furry friends with peace of mind, wherever you are.',
  getStarted: 'Get Started',
  learnMore: 'Learn More',
  signUp: 'Sign Up Now',

  // Stats
  happyPets: 'Happy Pets',
  usersFamilies: 'User Families',
  careProfiles: 'Care Profiles',
  satisfactionRate: 'Satisfaction Rate',

  // How It Works
  easiestWay: 'The Easiest Way',
  howItWorks: 'How It Works',
  howItWorksSubtitle: 'Get started managing your pet\'s health and care in just three simple steps',
  forPetOwners: 'For Pet Owners',
  forCaregivers: 'For Caregivers',

  // Steps for Pet Owners
  createPetProfile: 'Create Pet Profile',
  createPetProfileDesc: 'Add detailed information about your pet, including health records, diet, and care needs',
  shareWithCaregivers: 'Share with Caregivers',
  shareWithCaregiversDesc: 'Securely share pet information with family, friends, or professional caregivers',
  travelWithPeace: 'Travel with Peace',
  travelWithPeaceDesc: 'Travel confidently knowing your pet is getting the best care while you\'re away',

  // Steps for Caregivers
  accessPetDetails: 'Access Pet Details',
  accessPetDetailsDesc: 'Instantly view all important pet information and care instructions',
  followSchedules: 'Follow Schedules',
  followSchedulesDesc: 'Keep track of feeding times, medications, and other important care tasks',
  stayConnected: 'Stay Connected',
  stayConnectedDesc: 'Communicate with pet owners and share updates',

  // Features
  whyChooseUs: 'Why Choose Us',
  features: 'Core Features',
  featuresSubtitle: 'Comprehensive care tools designed for you and your pets',
  
  featureTitle1: 'Comprehensive Pet Profiles',
  featureDesc1: 'Store all pet information including health records, vaccinations, medications, and more',
  
  featureTitle2: 'Secure Sharing',
  featureDesc2: 'Share pet information securely with caregivers with full control over who can access what',
  
  featureTitle3: 'Real-time Updates',
  featureDesc3: 'Get instant notifications about your pet\'s health and care activities',

  scheduleFeature: 'Schedule Management',
  scheduleFeatureDesc: 'Track feeding times, medications, vet appointments, and other important events',

  healthFeature: 'Health Tracking',
  healthFeatureDesc: 'Monitor weight, vaccinations, allergies, and health conditions',

  mobileFeature: 'Mobile Friendly',
  mobileFeatureDesc: 'Access your pet information anytime, anywhere, on any device',

  viewAllFeatures: 'View All Features',

  // App Preview
  seamlessExperience: 'Seamless Experience',
  appPreviewTitle: 'Powerful Yet Intuitive Interface',
  appPreviewDescription: 'Our app is designed to make pet care simple and enjoyable. All features are at your fingertips.',
  
  multiUserAccess: 'Multi-User Access',
  multiUserAccessDesc: 'Collaborate with family and caregivers to care for your pets',
  
  healthTracking: 'Health Tracking',
  healthTrackingDesc: 'Monitor weight, vaccinations, and vet visits',
  
  premiumFeature: 'Premium Features',
  premiumFeatureDesc: 'Unlock advanced tools for better pet care',

  petDashboard: 'Pet Dashboard',
  dog: 'Dog',
  years: 'years',
  healthyStatus: 'Healthy',
  nextFeeding: 'Next Feeding',
  nextMedication: 'Next Medication',
  weight: 'Weight',
  nextVetVisit: 'Next Vet Visit',
  profileCompletion: 'Profile Completion',
  viewDetails: 'View Details',
  updateProfile: 'Update Profile',

  // Testimonials
  happyUsers: 'Happy Users',
  testimonials: 'User Testimonials',
  testimonialsSubtitle: 'See what other pet owners are saying about Pet Care Note',

  testimonial1: 'This app has transformed how I manage my pets\' care! I can easily track all their health records.',
  testimonial1Author: 'Sarah Chen',
  testimonial1Role: 'Owner of 3 Cats',

  testimonial2: 'As a pet sitter, this app makes my job so much easier. All the information I need is in one place!',
  testimonial2Author: 'John Smith',
  testimonial2Role: 'Professional Pet Sitter',

  testimonial3: 'Finally, an app that covers all my pet care needs. Highly recommended!',
  testimonial3Author: 'Emily Johnson',
  testimonial3Role: 'Owner of 2 Dogs',

  testimonial4: 'The sharing feature is perfect for coordinating pet care with family members.',
  testimonial4Author: 'Michael Lee',
  testimonial4Role: 'Family Pet Owner',

  testimonial5: 'I love that I can track my dog\'s vaccinations and vet appointments. So organized!',
  testimonial5Author: 'Jessica Brown',
  testimonial5Role: 'Owner of 1 Dog',

  testimonial6: 'This app is a game-changer for my pet care business.',
  testimonial6Author: 'David Wilson',
  testimonial6Role: 'Pet Care Professional',

  // CTA
  readyToStart: 'Ready to Get Started?',
  ctaTitle: 'Start Your Pet Health Journey Today',
  ctaDescription: 'Join thousands of pet owners who trust Pet Care Note to care for their furry friends',

  learnMoreAbout: 'Learn more about',
  aboutUs: 'About Us',
  contactSupport: 'Contact Support',
  privacyPolicy: 'Privacy Policy',

  // Pet types
  corgi: 'Corgi',
  siameseCat: 'Siamese Cat',
  borderCollie: 'Border Collie',
  caregiver: 'Caregiver',
  location: 'Location',
  home: 'Home',
};